import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';
import { AtlassianIcon } from '@atlaskit/logo';

import { ATLASSIAN_ACCOUNT_ID } from '../constants/snippetOwner.ts';
import type { SnippetOwner, UserSnippetOwner } from '../types/snippetOwner.ts';

export type SnippetCreatedByAvatarProps = {
	snippetOwner: SnippetOwner;
};

export const SnippetCreatedByAvatar = ({
	snippetOwner,
}: SnippetCreatedByAvatarProps): React.JSX.Element => {
	const shouldUseAtlassianIcon =
		snippetOwner.accountId.toLowerCase() === ATLASSIAN_ACCOUNT_ID.toLowerCase();
	if (shouldUseAtlassianIcon) {
		return <AtlassianIcon appearance="brand" size="xsmall" />;
	}

	return (
		<Avatar
			appearance="circle"
			size="xsmall"
			src={(snippetOwner as UserSnippetOwner).avatarUrl}
			name={snippetOwner.displayName}
		/>
	);
};
